import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Home,
  Article,
  EditorNote,
  AboutUs,
  Contact,
  Privacy,
  TermCondition,
  RefundCancellation,
  DeliveryShipping,
  Search,
  PodcastVideo,
  Author,
  Subscription,
  DailyCrossword,
  Profile,
  Subject,
  Login,
  Register,
  ForgotPassword,
  NewsLetter,
  SubscriptionThankyou,
  ProfileEdit,
  NewsLetterArtsAndCulture,
  NewsLetterEnvironment,
  NewsLetterSports,
  SubscriptionInActive,
  SubscriptionActive,
  PageNotFound,
  ResetPassword,
  CrosswordSingle,
  Archive,
  FAQ,
} from "./pages";
import PhotoStory from "./pages/PhotoStory";
import PaymentSuccess from "./pages/PaymentSuccess";
import coinImage from "././assets/images/coin.gif";
import coin from "././assets/images/coinwithbg.gif";

import { useAlert } from "react-alert";
import Config from "./values/Strings/Config";
import "./assets/css/maintenancepage.css";

const MaintenancePage = ({ onPasswordSubmit }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showLoginForm, setShowLoginForm] = useState(false);

  const alert = useAlert();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === "93d8f3ba") {
      sessionStorage.setItem("isLoggedIn", "true");
      onPasswordSubmit(true);
    } else {
      setError("Incorrect password");
    }
  };

  // Toggle visibility of the login form
  const handleShowLoginForm = () => {
    setShowLoginForm(true);
  };


  const submitEmailAddress = (email) => {

    fetch(Config.NEWSLETTER_SUBSCRIPTION_URL, {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.success === true) {
          
          alert.success(
            <div style={{ textTransform: "initial" }}>{res?.data?.message}</div>
          );
        }
      })
      .catch((err) => {
        alert.success(
          <div style={{ textTransform: "initial" }}>{err?.message}</div>
        );
      });
  };

  const [email, setEmail] = useState("");

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (email.trim() !== "") {
      submitEmailAddress(email);
      setEmail(""); // Clear input after submission
    }
  };

  return (
    <div className="maintenance-container">
      <div className="content-box">
        <img loading="lazy" src={coin} alt="coin animation" className="coin-img" />
        <h4 className="notification-text">
          Be the first to get notified when we are live.
        </h4>
        <div className="email-signup">
          <form className="email-form" onSubmit={handleEmailSubmit}>
            <input
              type="email"
              placeholder="Enter email address here"
              className="email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="submit-btn">&gt;</button>
          </form>
        </div>
      </div>

      {showLoginForm && (
        <div className="login-form">
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="password-input"
            />
            <button type="submit" className="login-submit">
              Submit
            </button>
          </form>
          {error && <p className="error-text">{error}</p>}
        </div>
      )}

      <button className="show-login-btn" onClick={handleShowLoginForm}>
        <span className="code-symbol">&lt;&gt;</span>
      </button>
    </div>
  );
};

const Navigation = () => {

  const [isLoggedIn, setIsLoggedIn] = useState(true); //make this true to unlock the app | false to lock the app

  useEffect(() => {
    // Check if user is logged in
    const loggedInStatus = sessionStorage.getItem("isLoggedIn");
    if (loggedInStatus === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  if (!isLoggedIn) {
    return (
      <MaintenancePage
        onPasswordSubmit={(status) => setIsLoggedIn(status)}
      />
    );
  }

  return (
    <BrowserRouter basename="/">
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/article/:id" element={<Article />} />
          <Route path="/photostory/:id" element={<PhotoStory />} />
          <Route path="/issue-dispatch" element={<EditorNote />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<TermCondition />} />
          <Route path="/refund-and-cancellations" element={<RefundCancellation />} />
          <Route path="/delivery-and-shipping" element={<DeliveryShipping />} />
          <Route path="/search" element={<Search />} />
          <Route path="/videos-podcasts" element={<PodcastVideo />} />
          <Route path="/author/:id" element={<Author />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/daily-crossword" element={<DailyCrossword />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/subject/:id" element={<Subject />} />
          <Route path="/sign-in" element={<Login />} />
          <Route path="/sign-up" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/newsletter" element={<NewsLetter />} />
          <Route path="/subscription-success" element={<SubscriptionThankyou />} />
          <Route path="/profile-edit" element={<ProfileEdit />} />
          <Route path="/newsletter-arts-and-culture" element={<NewsLetterArtsAndCulture />} />
          <Route path="/newsletter-environment" element={<NewsLetterEnvironment />} />
          <Route path="/newsletter-sports" element={<NewsLetterSports />} />
          <Route path="/subscription-inactive" element={<SubscriptionInActive />} />
          <Route path="/subscription-active" element={<SubscriptionActive />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/crossword/:slug" element={<CrosswordSingle />} />
          <Route path="/archives" element={<Archive />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
};

export default Navigation;
